export const pluralYear = number => number > 1 ? `${number} years` : `${number} year`